import { ContentTemplate } from 'web-library';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { makeStyles } from 'tss-react/mui';
import { UseFormReturn } from 'react-hook-form';
import ControlledAutocomplete from '../../../../components/form-items/ControlledAutocomplete';
import { ExamSchoolFormData, ExamSchoolFormDataSPERS } from '../../../../models';
import { useGetMotherTongueLanguages } from '../../../../api-refactored/non-national-exam-registration/useGetMotherTongueLanguages';

const useStyles = makeStyles()((theme) =>
({
  input: {
    marginBottom: theme.spacing(6),
  },
}));

interface MotherTongueLanguageSectionProps {
  formHook: UseFormReturn<ExamSchoolFormData> | UseFormReturn<ExamSchoolFormDataSPERS>;
  selectedMotherTongueLanguage: string;
  hasEditAccess: boolean;
}

const MotherTongueLanguageSection = ({
  formHook,
  selectedMotherTongueLanguage,
  hasEditAccess,
}: MotherTongueLanguageSectionProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  // const { uuid } = useParams<{ uuid: string }>();

  const { formState: {errors} } = formHook;

  const {
    data: motherTongueLanguagesData,
    isLoading: isLoadingMotherTongueLanguagesData,
  } = useGetMotherTongueLanguages({
    onSuccess: () => null,
  });

  return (
    <ContentTemplate continuous isDividerBottom>
      {!isLoadingMotherTongueLanguagesData && (
        <ControlledAutocomplete
          id="selectInput-motherTongue"
          isRequired
          name="motherTongueLanguageToBeTaken"
          control={formHook.control}
          label={t('exam->>candidateDetails.motherTongue')}
          options={motherTongueLanguagesData || []}
          getOptionLabel={(option) => (typeof option === 'string' ? option : option.description)}
          isOptionEqualToValue={(option, value) => option.code === value.code}
          className={classes.input}
          placeholder="Select mother tongue language"
          error={!!errors?.motherTongueLanguageToBeTaken}
          helperText={errors?.motherTongueLanguageToBeTaken?.message?.toString()}
          defaultValue={motherTongueLanguagesData?.find(
            (option) => option.code === selectedMotherTongueLanguage
          )}
          disableClearable
          disabled={!hasEditAccess}
        />
      )}
    </ContentTemplate>
  );
};

export default MotherTongueLanguageSection;
